/**
* 头部菜单
*/
<template>
  <div>
    <el-menu class="el-menu-demo" mode="horizontal" background-color="#0C193D" text-color="#fff"
             active-text-color="#fff">
      <el-button class="buttonimg">
        <img class="logo" src="/static/img/logo02.png">
      </el-button>
      <el-submenu index="2" class="submenu">
        <!-- <template slot="title">{{user.userRealName}}</template> -->
        <template slot="title">{{userName}}</template>
        <el-menu-item @click="changePwd()" index="2-1">修改密码</el-menu-item>
        <el-menu-item @click="exit()" index="2-2">退出</el-menu-item>
      </el-submenu>
      <div class="message_button submenu" @click="gotoSystem">
        <el-tooltip placement="bottom" effect="light">
          <div slot="content" v-for="(item , index) in tableDataList.slice(0, 5)" :key="index" class="card">
            <div class="flex_box">
              <p class="messageTitle f12 pointer">{{ item.message_title }}</p>
              <template class="status">
                <el-button size="mini" type="danger" @click="gotoSystem" round v-if="item.handler_status=='0'">未处理
                </el-button>
                <el-button size="mini" type="warning" @click="gotoSystem" round v-else>已处理</el-button>
              </template>
            </div>
            <p class="messageContent pointer" @click="gotoSystem">{{ item.message_content }}</p>
          </div>
          <div class="empty" slot="content" v-if="isEmpty">
            <el-empty :image-size="100"></el-empty>
          </div>
          <div class="icon">
            <el-button type="text">
              <el-badge :is-dot="hasNewData" class="item">
                <i class="el-icon-message colorfff"></i>
              </el-badge>
              <!--              <el-badge is-dot class="item" :hidden="hasNewData">-->
              <!--                <i class="el-icon-message colorfff"></i>-->
              <!--              </el-badge>-->
            </el-button>
          </div>
        </el-tooltip>
      </div>
    </el-menu>
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               title="修改密码"
               :visible.sync="changePwdDialogVisible"
               width="22%"
               center>
      <div class="passwordForm">
        <div class="tip">字母+数字组合，长度为6-20位字符，请至少包含一个大写字母。</div>
        <el-form label-width="120px" :model="passwordForm" :rules="rules" ref="passwordForm">
          <el-form-item label="" prop="old_pwd">
            <el-input placeholder="请输入原密码" v-model="passwordForm.old_pwd" show-password></el-input>
          </el-form-item>
          <el-form-item label="" prop="new_pwd">
            <el-input placeholder="请输入新密码" v-model="passwordForm.new_pwd" show-password></el-input>
          </el-form-item>
          <el-form-item label="" prop="crm_new_pwd">
            <el-input placeholder="请再次输入新密码" v-model="passwordForm.crm_new_pwd" show-password></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
                    <el-button @click="changePwdDialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="sureChangePwd('passwordForm')">确 定</el-button>
              </span>
    </el-dialog>
  </div>
</template>
<script>
  import {loginout, updatePwd, session} from '../api/userMG'
  import {systemMessageList} from "../api/basisMG";

  export default {
    name: 'navcon',
    data() {
      var validatePass = (rule, value, callback) => {
        const reg = /^[a-zA-Z0-9]{6,20}$/;
        const regs = /[A-Z]/;
        if (value === '') {
          callback(new Error('请输入密码'));
        } else if (!reg.test(value) || !regs.test(value)) {
          callback(new Error('长度为6-20位字母+数字组合的字符，至少包含一个大写字母。'));
        } else {
          if (this.passwordForm.crm_new_pwd !== '') {
            this.$refs.passwordForm.validateField('crm_new_pwd');
          }
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.passwordForm.new_pwd) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      return {
        collapsed: true,
        changePwdDialogVisible: false,
        logining: false,
        password: '',
        userName: '',
        passwordForm: {
          old_pwd: '',
          new_pwd: '',
          crm_new_pwd: ''
        },
        // rules表单验证
        rules: {
          old_pwd: [
            {required: true, message: '请输入原密码', trigger: 'blur'}
          ],
          new_pwd: [
            {validator: validatePass, trigger: 'blur'}
          ],
          crm_new_pwd: [
            {validator: validatePass2, trigger: 'blur'}
          ],
        },
        tableDataList: [],
        hasNewData: false,
        hasNew: '',
        isEmpty: true,
        socket: '',
        lockReconnect: false, // websokect 锁
        timeoutnum: null, //断开 重连倒计时
        timeoutObj:null,
      }
    },
    // 创建完毕状态(里面是操作)
    created() {
      this.userName = localStorage.getItem('userName');
    },
    mounted() {
      this.getdata();
      this.initWebsocket()
      // this.checkForNewData();
    },
    watch: {
      // 监听 tableDataList 的变化
      tableDataList: {
        handler(newValue, oldValue) {
          // 当 tableDataList 发生变化时，检查是否有新数据
          // if (newValue.length > oldValue.length) {
          //   this.hasNewData = true; // 如果有新数据，显示小红点
          // } else {
          //   this.hasNewData = false; // 否则隐藏小红点
          // }
        },
        deep: true // 深度监听，如果 tableDataList 是一个对象数组，需要深度监听其内部变化
      }
    },
    methods: {
      //开启心跳
      start:function () {
        this.timeoutObj && clearTimeout(this.timeoutObj);
        let that = this;
        this.timeoutObj = setTimeout(function() {
          //这里发送一个心跳，后端收到后，返回一个心跳消息，
          if (that.socket.readyState == 1) {
            //如果连接正常
            that.socket.send('0');
            that.start();
            console.log("发送心跳");
          } else {
            //否则重连
            that.reconnect(); //重连
          }
        }, 5000);
      },
      open: function () {
        console.log("socket连接成功")
        this.start()
      },
      error: function () {
        this.reconnect()
        console.log("连接错误")
      },
      getMessage: function (msg) {
        let data = {
          handler_status: 0,
          message_content: JSON.parse(msg.data).message,
          message_title: JSON.parse(msg.data).msgTitle
        }
        this.tableDataList.unshift(data)
        this.hasNewData = true;
        if (this.tableDataList.length) {
          this.isEmpty = false
        }
      },
      // 发送消息给被连接的服务端
      send: function (params) {
        this.socket.send(params)
      },
      close: function () {
        console.log("socket已经关闭")
        // this.reconnect(); //重连
      },
      reconnect() {
        var that = this;
        if (that.lockReconnect) {
          return;
        }
        that.lockReconnect = true;
        //没连接上会一直重连，设置延迟避免请求过多
        that.timeoutnum && clearTimeout(that.timeoutnum);
        that.timeoutnum = setTimeout(function () {
          that.initWebsocket(); //新连接
          that.lockReconnect = false;
        }, 5000);
      },
      // checkForNewData() {
      //   this.hasNew = this.tableDataList
      //   // 检查是否有新数据
      //   if (hasNew = true) {
      //     this.hasNewData = true;
      //   }
      // },
      initWebsocket() {
        session().then(res => {
          let url = process.env.WEBSOCKET_URL;
          this.socket = new WebSocket(url + '/service/ws/cli?sid=' + res.content.sid + '&timestamp=' + res.content.timestamp + '&sign=' + res.content.sign)
          this.socket.onopen = this.open
          // 监听socket错误信息
          this.socket.onerror = this.error
          // 监听socket消息
          this.socket.onmessage = this.getMessage
          // 监听socket关闭
          this.socket.onclose = this.close
        })
      },
      // 获取公司列表
      getdata() {
        this.loading = true
        let param = {
          page: 0,
          rows: 0,
          message_word: '',
          message_type: '',
          handler_status: '0',
          start_create_time: '',
          end_create_time: '',
        }
        systemMessageList(param)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.tableDataList = res.content.rows;
              if(res.content.rows) {
                this.isEmpty = false
              }
              this.hasNewData = false;
              for (let i in this.tableDataList) {
                if (this.tableDataList[i].handler_status == 0) {
                  this.hasNewData = true;
                  return
                }
              }
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 跳转到系统消息页面
      gotoSystem() {
        localStorage.setItem('path', '/system/systemMessages')
        let tag = {
          url: "/system/systemMessages",
          menuname: "系统消息"
        }
        this.$store.commit('selectMenu', tag)
        this.$router.push({path: '/system/systemMessages'})
        if (this.tableDataList.length) {
          this.isEmpty = false
        }
      },
      //修改密码
      changePwd() {
        this.changePwdDialogVisible = true;
      },
      sureChangePwd(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.loading = true
            updatePwd(this.passwordForm)
              .then(res => {
                this.loading = false
                if (res.success == false) {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                } else {
                  this.$message({
                    type: 'success',
                    message: '修改成功!'
                  })
                  this.$store.commit('logout', 'false')
                  localStorage.setItem('path', '/dashboard/Dashboard')
                  this.$router.push({path: '/login'})
                }
              })
              .catch(err => {
                this.loading = false
                this.$message.error('网络错误，请稍后再试！')
              })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      loginoutApi() {
        loginout()
          .then(res => {
            if (res.success) {
              //如果请求成功就让他2秒跳转路由
              setTimeout(() => {
                this.$store.commit('logout', 'false')
                localStorage.setItem('path', '/dashboard/Dashboard')
                localStorage.removeItem('logintoken')
                this.$router.push({path: '/login'})
                this.$store.commit('clear')
                this.$message({
                  type: 'success',
                  message: '已退出登录!'
                })
              }, 1000)
            } else {
              this.$message.error(res.msg)
              this.logining = false
              return false
            }
          })
          .catch(err => {
            // 获取图形验证码
            this.getcode()
            this.logining = false
            this.$message.error('退出失败，请稍后再试！')
          })
      },
      // 退出登录
      exit() {
        this.$confirm('退出登录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.logining = true
            this.loginoutApi()
            // setTimeout(() => {
            //   this.$store.commit('logout', 'false')
            //   this.$router.push({ path: '/login' })
            //   this.$message({
            //     type: 'success',
            //     message: '已退出登录!'
            //   })
            // }, 1000)
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            })
          })
      },
      // 切换显示
      toggle(showtype) {
        this.collapsed = !showtype
        this.$root.Bus.$emit('toggle', this.collapsed)
      },
      beforeDestroy() {
        // 销毁监听
        this.socket.close()
        clearTimeout(this.timeoutObj);
      }
    }
  }
</script>
<style scoped>
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    border: none;
  }

  .submenu {
    float: right;
  }

  .buttonimg {
    height: 60px;
    background-color: transparent;
    border: none;
  }

  .tip {
    font-size: 12px;
    color: #999999;
    margin-bottom: 10px;
  }

  .logo {
    width: 186px;
    height: 28px;
  }

  /deep/ .passwordForm .el-form-item__content {
    margin-left: 0 !important;
  }

  /deep/ .icon .el-button--text {
    color: #ffffff;
  }

  /deep/ .icon .el-button {
    padding: 0;
    font-size: 20px;
  }

  .height12 {
    height: 12px;
  }

  .message_button {
    height: 60px;
    line-height: 60px;
    margin-right: 30px;
  }

  .colorfff {
    color: #FFFFFF;
  }

  .card {
    width: 205px;
    padding: 10px;
    border-bottom: 1px solid #EBEEF5;
  }

  .messageTitle {
    line-height: 16px;
    font-weight: 500;
    margin-right: 10px;
  }

  .messageContent {
    margin-top: 10px;
    width: 185px;
    height: 30px;
    font-size: 10px;
    line-height: 15px;
    color: #666666;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  /deep/ .status .el-button--mini, .el-button--mini.is-round {
    padding: 2px 4px;
  }

  /deep/ .status .el-button--mini {
    font-size: 10px;
  }

  /deep/ .tooltip .el-tooltip__popper {
    padding: 8px 10px;
  }

  .empty {
    width: 225px;
  }

  .pointer {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/navcon.vue